import fslightbox from "fslightbox";
import SingleDoctorSlider from "./components/single-doctor-slider";
import Modal from "./components/modal";

document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector(".doctor-swiper");

  if (typeof gallery !== undefined && typeof gallery !== null) {
    new SingleDoctorSlider(gallery);
  }

  const modal = document.querySelector(".widget");

  if (typeof modal !== undefined && typeof modal !== null) {
    new Modal(modal);
  }
});
